<div class="d-flex flex-column justify-content-center align-items-center">
    <div class="text-center process-step-title text-montserrat">Paso 2</div>
    <div class="text-center my-2 text-montserrat">Recolección de documentos</div>
    <div class="text-center my-1 text-montserrat">
        Para confirmar la cancelación de la póliza, es necesario cargar los siguientes documentos:
    </div>
    <form [formGroup]="adjuntosForm">
        <div class="w-100 my-2">
            <app-input-file formControlName="idAnverso" [title]="'INE (Frente)'" [typeImage]="'anverso'"></app-input-file>
        </div>
        <div class="w-100 my-2">
            <app-input-file formControlName="idReverso" [title]="'INE (Reverso)'" [typeImage]="'reverso'"></app-input-file>
        </div>
        <div class="w-100 my-2">
            <app-input-file formControlName="comprobanteDomicilio" [title]="'Comprobante de domicilio (No mayor a 3 meses)'" [typeImage]="'comprobante'"></app-input-file>
        </div>
    </form>
</div>